import { IPanelStyles, Panel, PanelType } from "@fluentui/react";
import React from "react";
import '../../../../styles/taskpane.css'

interface IWebPanelProps {
  headerText?: string;
  isOpen: boolean;
  closePanel(): any;
  children?: JSX.Element;
  width?: string;
  styles?: Partial<IPanelStyles>
}

// const panelStyles:Partial<IPanelStyles> = {
//   content: {
//     paddingLeft: 5,
//     paddingRight: 0
//   }
// }

export const WebPanel = (props: IWebPanelProps) => {
  const { headerText, isOpen, closePanel, children, width, styles } = props;

  const [panelIsOpen] = React.useState(isOpen);

  return (
    <Panel
      headerText={headerText}
      isOpen={panelIsOpen}
      onDismiss={() => closePanel()}
      isLightDismiss
      closeButtonAriaLabel="Close"
      type={PanelType.custom}
      customWidth={width ? width : '350px'}
      styles={styles}
    >
      {children}
    </Panel>
  );
};
